import React, { Component } from 'react';
import Modal from 'react-modal';
import KTP from '../../containers/ktp/KTPContainer';
import { withTranslation } from 'react-i18next';


class KTPList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
    };
    this.toggleModal = this.toggleModal.bind(this);
    this.renderListItem = this.renderListItem.bind(this);
  }

  componentDidMount() {
    // this.props.didMount();
    window.scrollTo(0, 0);
  }

  toggleModal(id) {
    this.setState({ modal: id });
  }

  renderListItem(ktp, i) {
    return (
      <div
        className="modal-react"
        key={ktp.id}
        tabIndex={i}
        onClick={() => this.toggleModal(ktp.id)}
        role="button"
      >
        {ktp.name}
        <div className="modal-react__edit" />
        <div className="modal-react__delete" />
      </div>
    );
  }

  render() {
    const { list, t } = this.props;
    const { modal } = this.state;
    return (
      <div>
        <div className="captions">{t('Факультеты')}</div>
        {list.map(this.renderListItem)}
        <Modal
          isOpen={!!modal}
          onRequestClose={() => this.toggleModal(false)}
          contentLabel="Modal"
        >
          <KTP id={modal} onRequestClose={() => this.toggleModal(false)} />
        </Modal>
      </div>
    );
  }
}

export default withTranslation()(KTPList);